import { render } from "./News.vue?vue&type=template&id=b429b814&scoped=true"
import script from "./News.vue?vue&type=script&lang=ts"
export * from "./News.vue?vue&type=script&lang=ts"

import "./News.vue?vue&type=style&index=0&id=b429b814&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b429b814"

export default script